module.exports = __webpack_public_path__ + "img/tree-04-a-trunk.46f9783d.png";